import menu from './menu';
import dialog from './dialog';
import pagination from './pagination';

export default {
	menu,
	dialog,
	pagination,
};
